import { showAlert } from "../components/Helpers/Utils";

const priorityFunc = () => {
  const formData = new FormData(document.getElementById("frmCreatePriority"));
  createType(formData)
    .then((data) => {
     showAlert(data, "success");
    })
    .catch((error) => {
      console.log(error);
    });
};

const createType = async (formDt) => {
  const url = "https://www.innovations.co.ke/portalapi/public/api/createPriority";
  const options = {
    method: "POST",
    body: formDt,
  };
  const response = await fetch(url, options);
  if (response.status !== 200) {
    throw new Error("There was an error creating Client :" + response.status);
  }
  const data = await response.json();
  return data;
};

const CreatePriority = () => {
  return (
    <div className="card col-md-4 mx-auto" style={{ marginTop: "20%" }}>
      <div className="card-header text-center bg-white">
        <h1>
          <span className="text-danger fw-bolder">Create </span>
          <span className="text-info fst-italic">Priority</span>
        </h1>
      </div>
      <div className="card-body">
        <form id="frmCreatePriority" className="d-grid gap-3">
          <div className="form-group">
            <label htmlFor="role">Priority</label>
            <input
              type="text"
              className="form-control"
              autoComplete="off"
              id="priority"
              name="priority"
              required
            />
          </div>
          <button
            type="button"
            id="submit"
            onClick={priorityFunc}
            className="btn btn-secondary mx-auto fs-5"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreatePriority;
